<div class="table-container mat-elevation-z2">
  <app-pagination
    *ngIf="tableFilters.count > tableFilters.itemsPerPage"
    [tableFilters]="tableFilters"
    (tableFiltersUpdated)="updateTableFilters($event)"></app-pagination>
  <div class="mat-table">
    <mat-table [dataSource]="dataSource" matSort matSortDisableClear>
      <ng-container matColumnDef="{{ columns.STUDENT_ID }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.STUDENT_ID}}
        </mat-header-cell>
        <mat-cell *matCellDef="let reactionEntry">
          <a
            [routerLink]="['/students', reactionEntry.studentId, 'profile']"
            target="_blank"
            rel="noopener noreferrer">
            {{ reactionEntry.studentExtId }}
          </a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.LAST_NAME }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.LAST_NAME}}
        </mat-header-cell>
        <mat-cell *matCellDef="let reactionEntry">
          {{ reactionEntry.studentLastName }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.FIRST_NAME }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.FIRST_NAME}}
        </mat-header-cell>
        <mat-cell *matCellDef="let reactionEntry">
          {{ reactionEntry.studentFirstName }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.HOMEROOM }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.HOMEROOM}}
        </mat-header-cell>
        <mat-cell *matCellDef="let reactionEntry">
          {{ reactionEntry.homeroom }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.GRADE }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{columns.GRADE}} </mat-header-cell>
        <mat-cell *matCellDef="let reactionEntry">
          {{ reactionEntry.studentGrade }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.ENTRY_DATE }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.ENTRY_DATE}}
        </mat-header-cell>
        <mat-cell *matCellDef="let reactionEntry">
          {{
          DateUtil.convertToDisplayDate(reactionEntry.behaviorEntryDate)
          }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.ENTRY_TIME }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.ENTRY_TIME}}
        </mat-header-cell>
        <mat-cell *matCellDef="let reactionEntry">
          {{
            reactionEntry.behaviorEntryTime ?
          DateUtil.convertToDisplayTime(reactionEntry.behaviorEntryTime) : ''
          }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.BEHAVIOR_CODE }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.BEHAVIOR_CODE}}
        </mat-header-cell>
        <mat-cell *matCellDef="let reactionEntry">
          {{ reactionEntry.behaviorCodeName }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.REACTION }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.REACTION}}
        </mat-header-cell>
        <mat-cell *matCellDef="let reactionEntry">
          {{ reactionEntry.reactionName }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.REACTION_DATE }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.REACTION_DATE}}
        </mat-header-cell>
        <mat-cell *matCellDef="let reactionEntry">
          {{ reactionEntry.reactionDate ?
          DateUtil.convertToDisplayDate(reactionEntry.reactionDate) :
          '' }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.ISSUED_BY }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.ISSUED_BY}}
        </mat-header-cell>
        <mat-cell *matCellDef="let reactionEntry">
          {{ reactionEntry.issuedBy }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="{{ columns.COMPLY }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.COMPLY}}
        </mat-header-cell>
        <mat-cell *matCellDef="let reactionEntry">
          <ng-container *ngIf="reactionEntry.compliedDate">
            {{
            DateUtil.convertToDisplayDate(reactionEntry.compliedDate)
            }}
          </ng-container>
          <ng-container *ngIf="!reactionEntry.compliedDate">
            <button
              type="submit"
              mat-flat-button
              class="secondary-button"
              (click)="comply(reactionEntry.id)"
              options-id="COMPY_REACTION_ENTRY">
              <fa-icon [icon]="['fas', 'pencil']"></fa-icon>
            </button>
          </ng-container>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns;"></mat-header-row>
      <mat-row *matRowDef="let code; columns: displayedColumns;"></mat-row>
    </mat-table>
    <div
      *ngIf="tableFilters.count > tableFilters.itemsPerPage"
      class="table-filters-bottom">
      <app-pagination
        [tableFilters]="tableFilters"
        (tableFiltersUpdated)="updateTableFilters($event)"></app-pagination>
    </div>
  </div>
</div>
